// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__32FwK","isPrimary":"Button_isPrimary__xQIe9","isLarge":"Button_isLarge__3Qw5g"};